import type { Box3, Matrix4 } from 'three'
import type { RuntimeTileNode } from '@/plugins/tiles/hierarchy/ExplicitHierarchyProvider'
import type { TileSelectionRequest } from '@/plugins/tiles/runtime/TileSelector'
import { getMaximumStretch } from '@/plugins/tiles/spatial/tilesSpatial'

/** 碰撞以世界误差和兴趣区域选择，完全独立于相机/SSE/屏幕裁切。 */
export function selectCollisionTiles(
  root: RuntimeTileNode,
  bounds: Box3,
  placement: Matrix4,
  maxError: number
) {
  const nodes: RuntimeTileNode[] = []
  const requests: TileSelectionRequest[] = []
  let sourceLimited = false
  let unknown = false
  const stretch = getMaximumStretch(placement)
  const visit = (node: RuntimeTileNode) => {
    const intersects = bounds.intersectsBox(node.traversalBounds.clone().applyMatrix4(placement))
    if (!intersects && !node.hasUnknownDescendants) return
    if (
      node.description.content &&
      node.contentKind !== 'mesh' &&
      node.hierarchyState !== 'ready'
    ) {
      unknown = true
      requests.push({
        node,
        kind: node.contentKind === 'tileset' ? 'hierarchy' : 'classify',
        priority: 100,
        purpose: 'collision',
      })
      return
    }
    if (!intersects) {
      for (const child of node.children) visit(child)
      return
    }
    const refine = node.effectiveError * stretch > maxError || node.contentKind !== 'mesh'
    if (
      node.contentKind === 'mesh' &&
      (!refine || !node.children.length || node.description.refine === 'ADD')
    )
      nodes.push(node)
    if (refine && node.children.length) for (const child of node.children) visit(child)
    else if (refine && node.contentKind === 'mesh') sourceLimited = true
  }
  visit(root)
  return { nodes, requests, sourceLimited, unknown }
}
